const initialState = {
  loading:true,
};

export function fetchInterventionComment(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_INTERVENTION_COMMENT.SUCCESS':
      return {
        ...state,
        interventionComment:  action.interventionComment.body,
      };
    case 'SAVE_INTERVENTION_COMMENT.SUCCESS':
      return {
        ...state,
        interventionComment:  action.interventionComment.body,
      };
    default:
      return state
  }
}

